(() => {
  const rules = [
    { id: 'heat-transfer', pattern: /\bheat\s+transfers?\b/gi, replacement: 'DTF transfer' },
    { id: 'creepy', pattern: /\bcreepy\b/gi, replacement: 'horror' },
    { id: 'ready-now', pattern: /\b(?:no\s+wait|ready\s+now|need\s+it\s+now)\b/gi, replacement: 'ready to ship' },
    { id: 'cup', pattern: /\b(?:cups?|drinkware)\b/gi, replacement: 'tumbler' },
    { id: 'trades', pattern: /\btrades\b/gi, replacement: 'blue collar' },
    { id: 'nursing', pattern: /\bnursing\b/gi, replacement: 'nurse' }
  ];

  const clean = (value) => String(value || '').trim().replace(/\s+/g, ' ');

  const translate = (value) => {
    const original = clean(value);
    let query = original;
    const matches = [];

    rules.forEach((rule) => {
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(query)) return;
      rule.pattern.lastIndex = 0;
      query = query.replace(rule.pattern, rule.replacement);
      matches.push(rule.id);
    });

    query = clean(query)
      .replace(/\bhorror(?:\s+horror)+\b/gi, 'horror')
      .replace(/\bnurse(?:\s+nurse)+\b/gi, 'nurse')
      .replace(/\btumbler(?:\s+tumbler)+\b/gi, 'tumbler')
      .replace(/\bblue collar(?:\s+blue collar)+\b/gi, 'blue collar')
      .replace(/\bDTF transfer(?:\s+DTF transfer)+\b/gi, 'DTF transfer')
      .replace(/\bready to ship(?:\s+ready to ship)+\b/gi, 'ready to ship');
    return {
      original,
      query,
      matches,
      changed: Boolean(original) && query.toLowerCase() !== original.toLowerCase()
    };
  };

  const buildSearchUrl = (query, original) => {
    const url = new URL('/search', window.location.origin);
    url.searchParams.set('q', clean(query));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    if (clean(original)) url.searchParams.set('rec_original_q', clean(original));
    return `${url.pathname}?${url.searchParams.toString()}`;
  };

  const isSearchForm = (form) => {
    if (!(form instanceof HTMLFormElement) || !form.querySelector('input[name="q"]')) return false;
    try {
      const url = new URL(form.getAttribute('action') || '/search', window.location.origin);
      return url.pathname.replace(/\/+$/, '') === '/search';
    } catch (_) {
      return false;
    }
  };

  const normalizeSearchForm = (form) => {
    if (!isSearchForm(form)) return;
    const input = form.querySelector('input[name="q"]');
    const result = translate(input?.value);
    if (!result.changed) return;

    let original = form.querySelector('input[name="rec_original_q"]');
    if (!original) {
      original = document.createElement('input');
      original.type = 'hidden';
      original.name = 'rec_original_q';
      form.append(original);
    }
    original.value = result.original;
    input.value = result.query;
  };

  const maybeRedirectDirectSearch = () => {
    if (window.location.pathname.replace(/\/+$/, '') !== '/search') return false;
    const url = new URL(window.location.href);
    if (url.searchParams.has('rec_original_q')) return false;
    const result = translate(url.searchParams.get('q'));
    if (!result.changed) return false;

    url.searchParams.set('q', result.query);
    url.searchParams.set('rec_original_q', result.original);
    url.searchParams.delete('page');
    window.location.replace(url.toString());
    return true;
  };

  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };

  const renderSearchTranslation = () => {
    if (window.location.pathname.replace(/\/+$/, '') !== '/search') return;
    const params = new URLSearchParams(window.location.search);
    const original = clean(params.get('rec_original_q'));
    const current = clean(params.get('q'));
    const form = document.querySelector('.rec-search__form');
    if (!form || !original || !current || original.toLowerCase() === current.toLowerCase()) return;

    let box = document.querySelector('[data-rec-search-brain-note]');
    if (!box) {
      box = make('aside', 'rec-search-brain-note');
      box.dataset.recSearchBrainNote = 'true';
      box.setAttribute('aria-live', 'polite');
      box.append(
        make('span', 'rec-search-brain-note__kicker', 'REC BRAIN • SEARCH TRANSLATED'),
        make('strong', 'rec-search-brain-note__terms'),
        make('p', 'rec-search-brain-note__copy', 'Same intent. Better catalog language. Shopify still runs the product search.')
      );
      form.insertAdjacentElement('afterend', box);
    }
    const terms = box.querySelector('.rec-search-brain-note__terms');
    const label = `“${original}” → “${current}”`;
    if (terms && terms.textContent !== label) terms.textContent = label;
  };

  const renderPredictiveBrain = () => {
    const drawer = document.querySelector('#ftf-search-hidden');
    if (!drawer) return;
    const input = drawer.querySelector('[data-input-search]');
    const form = drawer.querySelector('[data-frm-search]');
    const result = translate(input?.value);
    let box = drawer.querySelector('[data-rec-psearch-brain]');

    if (!result.changed || !form) {
      drawer.classList.remove('rec-psearch--brain-active');
      box?.remove();
      return;
    }

    drawer.classList.add('rec-psearch--brain-active');
    if (!box) {
      box = make('aside', 'rec-psearch__brain');
      box.dataset.recPsearchBrain = 'true';
      const copy = make('div', 'rec-psearch__brain-copy');
      copy.append(
        make('span', '', 'REC BRAIN • BETTER MATCH'),
        make('strong', ''),
        make('p', '', 'Same intent. Better catalog language.')
      );
      const link = make('a', 'rec-psearch__brain-link');
      box.append(copy, link);
      form.insertAdjacentElement('afterend', box);
    }

    const title = box.querySelector('.rec-psearch__brain-copy strong');
    const link = box.querySelector('.rec-psearch__brain-link');
    const label = `“${result.original}” → “${result.query}”`;
    if (title && title.textContent !== label) title.textContent = label;
    if (link) {
      const linkLabel = `SEARCH “${result.query}” →`;
      if (link.textContent !== linkLabel) link.textContent = linkLabel;
      const href = buildSearchUrl(result.query, result.original);
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    }
  };

  const mountPredictive = () => {
    const drawer = document.querySelector('#ftf-search-hidden');
    if (!drawer || drawer.dataset.recSearchBrainBound === 'true') return;
    drawer.dataset.recSearchBrainBound = 'true';
    drawer.addEventListener('input', (event) => {
      if (event.target.matches('[data-input-search]')) renderPredictiveBrain();
    });
    renderPredictiveBrain();
  };


  const isHiddenFSFHref = (href) => {
    const value = String(href || '').toLowerCase();
    return value.includes('/products/fsf-')
      || value.includes('/pages/free-shit-friday')
      || value.includes('/pages/fsf-group-bonus');
  };

  const removeHiddenFSFResults = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      if (!isHiddenFSFHref(link.getAttribute('href'))) return;
      const card =
        link.closest('.ftf-product, .ftf-col-item, .ftf-space-item, .ftf-search-item, article, li')
        || link.parentElement;
      if (card) card.remove();
    });
  };

  const mountFSFFilter = () => {
    const targets = [];
    if (window.location.pathname.replace(/\/+$/, '') === '/search') {
      const searchRoot = document.querySelector('.ftf-main-collection-search');
      if (searchRoot) targets.push(searchRoot);
    }
    const drawer = document.querySelector('#ftf-search-hidden');
    if (drawer) targets.push(drawer);

    targets.forEach((target) => {
      removeHiddenFSFResults(target);
      if (target.dataset.recFsfFilterBound === 'true') return;
      target.dataset.recFsfFilterBound = 'true';
      new MutationObserver(() => removeHiddenFSFResults(target))
        .observe(target, { childList: true, subtree: true });
    });
  };

  window.RECSearchBrain = Object.freeze({ translate, buildSearchUrl });

  document.addEventListener('submit', (event) => normalizeSearchForm(event.target), true);

  const boot = () => {
    if (maybeRedirectDirectSearch()) return;
    renderSearchTranslation();
    mountPredictive();
    mountFSFFilter();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', () => {
    renderSearchTranslation();
    mountPredictive();
    mountFSFFilter();
  });
})();